var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('span', { staticClass: "edit-creative-info", on: { "click": _vm.open } }, [_vm.$slots.default ? _vm._t("default") : _c('svg-icon', { attrs: { "icon-class": "edit", "size": 24 } }), _vm._v(" "), _c('creative-info-dialog', _vm._b({ attrs: { "visible": _vm.dialogVisible, "action": _vm.action, "type": _vm.type }, on: { "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      } } }, 'creative-info-dialog', _vm.innerDialog, false), [_c('creative-info', { directives: [{ name: "loading", rawName: "v-loading", value: !_vm.creativeInfo.name, expression: "!creativeInfo.name" }], ref: "creative-info", attrs: { "action": _vm.action, "schema": _vm.schema, "creative-info": _vm.creativeInfo, "updateRequest": _vm.updateRequest, "createRequest": _vm.createRequest, "id": _vm.id, "type": _vm.type, "loading": _vm.loading, "read-mode": _vm.readMode }, on: { "update:loading": function updateLoading($event) {
        _vm.loading = $event;
      }, "cancel": _vm.close, "copy-success": function copySuccess(data) {
        _vm.close();
        _vm.$emit('copy-success', data);
      }, "create-success": function createSuccess(data) {
        _vm.close();
        _vm.$emit('create-success', data);
      }, "update-success": function updateSuccess(data) {
        _vm.close();
        _vm.$emit('update-success', data);
      } } })], 1)], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };